<template>
    <div>
        <b-row align-v="end">
            <b-col>
                <app-form-select-input
                    :options="mailTypes"
                    label="Tipo"
                    v-model="filters.type"
                ></app-form-select-input>
            </b-col>
            <b-col>
                <app-form-select-input
                    :options="[
                        { id: 0, name: 'Sin Entregar' },
                        { id: 1, name: 'Entregado' },
                    ]"
                    label="Estado"
                    v-model="filters.delivered"
                ></app-form-select-input>
            </b-col>
            <b-col>
                <app-autocomplete
                    :items="structures"
                    label="Destino"
                    v-model="filters.destination"
                    :get-object="false"
                ></app-autocomplete>
            </b-col>
            <b-col>
                <app-form-text-input
                    v-model="filters.owner"
                    label="Dueño"
                ></app-form-text-input>
            </b-col>
            <b-col>
                <app-form-text-input
                    v-model="filters.deliveredTo"
                    label="Entregado a"
                ></app-form-text-input>
            </b-col>
            <b-col>
                <b-btn
                    size="sm"
                    variant="secondary"
                    @click="$emit('filter', null)"
                    ><i class="fa fa-times"></i
                ></b-btn>
                <b-btn
                    size="sm"
                    variant="primary"
                    @click="$emit('filter', filters)"
                    ><i class="fa fa-filter"></i
                ></b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        venue: {
            type: Object,
        },
    },
    data: () => ({
        //
        filters: {
            type: '',
            destintation: '',
            owner: '',
            delivetedTo: '',
            delivered: 0,
        },
        structures: [],
        mailTypes: [],
    }),
    watch: {
        venue: {
            inmediate: true,
            handler(val) {
                if (!val) return
                this.loadStructures()
            },
        },
    },
    computed: {
        //
    },
    methods: {
        async loadStructures() {
            const { data } = await repo.get('structures', {
                venue: this.venue.id,
                accessPoint: false,
            })
            this.structures = data
        },
        async loadMailTypes() {
            const { data } = await repo.get('mail-types')
            this.mailTypes = data
        },
    },
    created() {
        this.loadMailTypes()
    },
}
</script>
